import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ReclamationService {

  constructor(private http:HttpClient) { }

  newReclamation(reclamation:any){
    return this.http.post<any>(
      `${environment.apiUrl}/Reclamations`,
       reclamation
    );
  }
}
